'use client'

import type { ReactNode } from 'react'
import { RowSurfaceProvider } from '@/deskUiSkeletons/rowTemplates/RowSurfaceContext'
import type { RowSkin, RowSurface } from '@/deskUiSkeletons/rowTemplates/RowTemplateTypes'
import { SubRow } from '@/deskUiSkeletons/subs/SubRow'
import { showQuickReplyModal } from '@/deskUiSkeletons/Shared/QuickReplyModal'
import { rowVariantRegistry } from './RowTemplateRegistry'
import { nestedTemplateVariant } from './RowTemplateConfig'
import { defaultBlockedPreviewSkin } from '@/msgComponents/skins/blockedPreviewSkin'

const forumRowSkin: RowSkin = {
  row: {
    base: 'clear-both list-none bg-transparent text-black',
    hidden: 'hidden',
    checked: '',
    foreign: 'opacity-90',
    foreignFrom: 'block pt-0.5 text-[11px] text-[#666] [&_a]:text-[#006699] [&_a]:no-underline [&_a:hover]:underline',
  },
  blockedNotice: { ...defaultBlockedPreviewSkin },
  icon: {
    base: 'inline-flex h-4 min-w-4 cursor-pointer items-center justify-center border border-[#006699] bg-[#eef3f8] px-0.5 align-middle text-[9px]',
    checkOn: 'bg-[#ffffcc]',
    checkOff: 'bg-[#eef3f8]',
    favOn: 'bg-[#ffdd99]',
    favOff: 'bg-[#eef3f8]',
    qrOn: 'bg-[#dfe6ef]',
    qrOff: 'bg-[#eef3f8]',
  },
  titleLink: 'font-bold text-[#006699] no-underline hover:underline',
  timeWrap: 'whitespace-nowrap text-[10px] text-white',
  timeText: 'whitespace-nowrap text-[10px] text-white',
  text: 'block min-w-0 whitespace-normal text-[11px] leading-[1.35] text-black',
  metaLink: 'mr-2 cursor-pointer text-[10px] text-[#006699] hover:underline',
  metaMore: 'mr-2 cursor-pointer text-[10px] text-[#006699] hover:underline',
  meta: 'text-[10px] text-[#006699]',
  feed: 'clear-both flex list-none flex-col gap-2 p-0',
  folder: {
    row: 'flex flex-col gap-1 border border-[#006699] bg-white px-2 py-1.5',
    head: 'flex min-w-0 items-center gap-1.5',
    title: 'min-w-0 flex-1 overflow-hidden text-ellipsis whitespace-nowrap text-[11px]',
    time: 'flex-[0_0_auto] whitespace-nowrap text-[10px] text-[#666]',
    text: 'min-w-0 overflow-hidden text-ellipsis whitespace-nowrap text-[11px] text-[#444]',
    counts: 'flex flex-wrap gap-x-2 text-[10px] text-[#006699]',
    count: 'whitespace-nowrap',
  },
}

const forumRowSurface: RowSurface = {
  SubRow,
  showQuickReplyModal,
  variants: rowVariantRegistry,
  config: { nestedTemplateVariant },
  skin: forumRowSkin,
}

export function ForumRowSurfaceProvider({ children }: { children: ReactNode }) {
  return <RowSurfaceProvider value={forumRowSurface}>{children}</RowSurfaceProvider>
}
